import React from 'react';
import styled from "styled-components";
import { toast } from 'react-toastify';
import FormContact from "./FormContact";
import FormConfirm from './FormConfirm';
import { useSelector } from "react-redux";
import FormActivity from "./FormActivity";
import { useEffect, useState } from "react";
import FormInventory from "./FormInventory";
import FormSearchRoom from "./FormSearchRoom";
import XrStepAv from "../../../components/XrStepAv.tsx";
import { apiGet, apiPost, objectToParams, API_URL_ROOM, API_URL_INVENTORY, API_URL_BOOKING, API_URL_ROLE } from "../../../helpers/api.ts";
import { useNavigate } from 'react-router-dom';

const RequestBookingPage = () => {
  const navigate = useNavigate();
  const token = useSelector((state) => state.authentication.token);
  const authorizedUser = useSelector((state) => state.authentication.authorizedUser);
  const steps = [
    {
      key: '01-detail-kegiatan',
      title: 'Detail Kegiatan',
    },
    {
      key: '02-cari-ruangan',
      title: 'Cari Ruangan',
    },
    {
      key: '03-peminjaman-inventaris',
      title: 'Peminjaman Inventaris',
    },
    {
      key: '04-identitas-pemohon',
      title: 'Identitas Pemohon',
    },
    {
      key: '05-konfirmasi',
      title: 'Konfirmasi',
    }
  ];
  const [errors, setErrors] = useState({
    notes: [],
    rooms: [],
    id_user: [],
    id_role: [],
    end_date: [],
    start_date: [],
    issuer_name: [],
    inventories: [],
    description: [],
    issuer_phone: [],
    estimate_participant: [],
  });
  const [form, setForm] = useState({
    notes: '',
    rooms: [],
    end_date: '',
    id_role: null,
    start_date: '',
    inventories: [],
    issuer_name: '',
    description: '',
    issuer_phone: '',
    estimate_participant: 0,
    id_user: (authorizedUser && authorizedUser.id) || null,
  });

  const [rooms, setRooms] = useState([]);
  const [roles, setRoles] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [inventories, setInventories] = useState([]);
  const [roomOptions, setRoomOptions] = useState([]);
  const [burrowedItems, setBurrowedItems] = useState([]);
  const [selectedRooms, setSelectedRooms] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [currentStep, setCurrentStep] = useState('01-detail-kegiatan');

  const populateData = async () => {
    try {
      const [ requestRooms, requestInventories, requestRoles ] = await Promise.all([
        apiGet(API_URL_ROOM.GET_ROOMS, token),
        apiGet(API_URL_INVENTORY.GET_INVENTORIES, token),
        apiGet(API_URL_ROLE.GET_ROLES, token)
      ]);
      const [ resultRooms, resultInventories, resultRoles ] = await Promise.all([
        requestRooms.json(),
        requestInventories.json(),
        requestRoles.json()
      ]);
      setRooms(resultRooms.data);
      setRoles(resultRoles.data);
      setInventories(resultInventories.data);
      setForm({ ...form, id_user: authorizedUser.id });
    } catch (error) {

    }
  }

  useEffect(() => {
    if (authorizedUser) {
      populateData();
    }
  }, [authorizedUser]);

  const actionFindRoom = async () => {
    if (isLoading) return;
    let hasError = false;
    const newErrors = {...errors};
    setLoading(true);

    if (!form.end_date) {
      hasError = true;
      newErrors.end_date = [ 'Jam selesai wajib diisi.' ];
    } else {
      newErrors.end_date = [];
    }
    if (!form.start_date) {
      hasError = true;
      newErrors.start_date = [ 'Jam mulai wajib diisi.' ];
    } else {
      newErrors.start_date = [];
    }
    if (!form.description) {
      hasError = true;
      newErrors.description = [ 'Nama kegiatan wajib diisi.' ];
    } else {
      newErrors.description = [];
    }
    if (!form.estimate_participant) {
      hasError = true;
      newErrors.estimate_participant = [ 'Estimasi jumlah peserta wajib diisi.' ];
    } else {
      newErrors.estimate_participant = [];
    }

    setErrors(newErrors);
    if (hasError) {
      toast.error('Tidak dapat mencari ruangan, mohon periksa kembali formulir yang Anda isi.');
      setLoading(false);
      return;
    }
    
    const payload = {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'applim  ion/json; charset=utf-8',
        'Accept': 'application/json; charset=utf-8'
      },
    };

    try {
      const payload = {
        start_time: form.start_date,
        end_time: form.end_date,
        status: 1
      };
      const request = await fetch(`${API_URL_BOOKING.FILTER_BOOKING}?${objectToParams(payload)}`, payload);
      const result = await request.json();
      const _roomOptions = [...rooms];
      result.data.forEach(bookingItem => {
        if (bookingItem.rooms.length > 0) {
          bookingItem.rooms.forEach(roomItem => {
            const deleteIndex = _roomOptions.findIndex(i => i.id === roomItem.id_room);
            if (deleteIndex > -1) {
              _roomOptions.splice(deleteIndex, 1);
            }
          })
        }
      });
      console.log(_roomOptions);
      setRoomOptions([..._roomOptions]);
      setCurrentStep('02-cari-ruangan');
    } catch (e) {
      toast.error('Terjadi kesalahan pada server, mohon coba kembali.');
    } finally {
      setLoading(false);
    }
  }

  const confirmBooking = async () => {
    const payload = {...form};
    if (!payload.notes) {
      payload.notes = 'Tidak ada catatan';
    }

    try {
      const request = await apiPost(API_URL_BOOKING.CREATE_BOOKING, token, payload);
      const result = await request.json();
      if (result.data) {
        navigate('/submissions');
        toast.success('Berhasil membuat permintaan peminjaman ruangan dan inventaris. Mohon menunggu hasil tinjauan dari tim PGDP.');
      }
    } catch (e) {
    }
  }

  const renderForm = () => {
    switch(currentStep) {
      case '01-detail-kegiatan':
        return (
          <FormActivity
            form={form}
            errors={errors}
            setForm={setForm}
            isLoading={isLoading}
            setErrors={setErrors}
            actionFindRoom={actionFindRoom}
          />
        );
      case '02-cari-ruangan':
        return (
          <FormSearchRoom
            form={form}
            errors={errors}
            setForm={setForm}
            isLoading={isLoading}
            setErrors={setErrors}
            rooms={rooms}
            roomOptions={roomOptions}
            selectedRooms={selectedRooms}
            setSelectedRooms={setSelectedRooms}
            setCurrentStep={setCurrentStep}
          />
        );
      case '03-peminjaman-inventaris':
        return (
          <FormInventory
            form={form}
            errors={errors}
            setForm={setForm}
            isLoading={isLoading}
            setErrors={setErrors}
            inventories={inventories}
            burrowedItems={burrowedItems}
            setBurrowedItems={setBurrowedItems}
            setCurrentStep={setCurrentStep}
          />
        );
      case '04-identitas-pemohon':
        return (
          <FormContact
            form={form}
            roles={roles}
            errors={errors}
            setForm={setForm}
            isLoading={isLoading}
            setErrors={setErrors}
            selectedRole={selectedRole}
            setSelectedRole={setSelectedRole}
            setCurrentStep={setCurrentStep}
          />
        );
      case '05-konfirmasi':
        return (
          <FormConfirm
            form={form}
            confirmBooking={confirmBooking}
            setCurrentStep={setCurrentStep}
          />
        );
      default:
        return <div />
    }  
  }

  return (
    <RequestBookingPageWrapper>
      <div className='requestBooking'>
        <div className='requestBooking__step'>
          {steps.map((step, index) => {
            return (
              <XrStepAv
                key={index}
                step={step.key}
                order={index + 1}
                title={step.title}
                activeStep={currentStep}
                status=''
                onClick={() => {}}
              />
            )
          })}
        </div>
        <div className='requestBooking__form'>
          {renderForm()}
        </div>
      </div>
    </RequestBookingPageWrapper>
  )
}

const RequestBookingPageWrapper = styled.div`
  & .requestBooking {
    display: flex;
    margin: 0 auto;
    max-width: 800px;

    &__step,
    &__form {
      padding: 20px;
    }

    &__step {
      width: 200px;
    }

    &__form {
      width: calc(100% - 200px); 
    }

    &__toolbar {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
`;

export default RequestBookingPage;